import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	list: [],
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
};

const devicesSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setDevicesData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;

			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
		},

		setLoadingDevices: (state, action) => {
			state.loading = action.payload;
		},
		setDeleteDevice: (state, action) => {
			state.data = state.data.filter((unit) => unit.id !== action.payload);
			state.totalItems -= 1;
			state.totalPage = Math.ceil(state.totalItems / state.perPage);
		},
		setAddDevice: (state, action) => {
			state.data.push(action.payload);
			state.totalItems += 1;
			state.totalPage = Math.ceil(state.totalItems / state.perPage);
		},
		setEditDevice: (state, action) => {
			const { id, updatedData } = action.payload;
			state.data = state.data.map((unit) => (unit.id === id ? { ...unit, ...updatedData } : unit));
		},
		setAllDevicesList: (state, action) => {
			const { data } = action.payload;

			state.list = data || [];
		},
	},
});

export const {
	setDevicesData,
	setLoadingDevices,
	setDeleteDevice,
	setAddDevice,
	setEditDevice,
	setAllDevicesList,
} = devicesSlice.actions;

export default devicesSlice.reducer;
